import React from 'react'

import { ORGANIZATION_LD } from 'helpers/SEOHelper'

const OrganizationLD = () => {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: ORGANIZATION_LD }} />
}

export default OrganizationLD
